import { useEffect } from 'react';

const setMetaTag = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const useDynamicMeta = ({ title, description, image, url }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    setMetaTag('og:title', title);
    setMetaTag('og:description', description);
    setMetaTag('og:image', image);
    setMetaTag('og:url', url);
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', image);
    return () => {
      document.title = prevTitle;
    };
  }, [title, description, image, url]);
};

export default useDynamicMeta;
